import { Drawer } from '@ashniva/ui';
import { Link } from 'react-router';

import { linesLabel } from '../ri-text';
import { useWorkspace, type CodeTarget } from '../workspace-context';
import { FileViewer } from './FileViewer';

/**
 * The cited lines in a side panel, so that following a citation does not lose the answer, the search or the analysis
 * it came from. Focus moves into the panel and back to the citation when it closes (the drawer is a modal dialog).
 */
export function CodeDrawer({
  target,
  onClose,
}: {
  target: CodeTarget | null;
  onClose: () => void;
}) {
  const workspace = useWorkspace();
  return (
    <Drawer
      open={target !== null}
      onClose={onClose}
      size="lg"
      title={target ? `${target.path}, ${linesLabel(target.start, target.end)}` : 'Code'}
      footer={
        target ? (
          <Link to={workspace.filesHref(target)} onClick={onClose}>
            Open the whole file
          </Link>
        ) : null
      }
    >
      {target ? (
        <FileViewer
          linkId={workspace.linkId}
          path={target.path}
          focus={{ start: target.start, end: target.end }}
          mode="around"
        />
      ) : null}
    </Drawer>
  );
}
